// Custom

import _AirdropAbi from './abis/Airdrop'
import _ComposableCoWAbi from './abis/ComposableCoW'
import _CowShedContractAbi from './abis/CowShedContract'
import _CoWSwapEthFlowAbi from './abis/CoWSwapEthFlow'
import _GPv2SettlementAbi from './abis/GPv2Settlement'
import _MerkleDropAbi from './abis/MerkleDrop'
import _Multicall3Abi from './abis/Multicall3'
import _SBCDepositContractAbi from './abis/SBCDepositContract'
import _SignatureVerifierMuxerAbi from './abis/SignatureVerifierMuxer'
import _TokenDistroAbi from './abis/TokenDistro'
import _vCowAbi from './abis/vCow'
import _ArgentWalletContractAbi from './abis-legacy/argent-wallet-contract'
import _ArgentWalletDetectorAbi from './abis-legacy/argent-wallet-detector'
import _Eip2612Abi from './abis-legacy/eip_2612'
import _EnsPublicResolverAbi from './abis-legacy/ens-public-resolver'
import _EnsAbi from './abis-legacy/ens-registrar'
import _Erc1155Abi from './abis-legacy/erc1155'
import _Erc20Abi from './abis-legacy/erc20'
import _Erc20Bytes32Abi from './abis-legacy/erc20_bytes32'
import _Erc721Abi from './abis-legacy/erc721'
import _UniswapInterfaceMulticallAbi from './abis-legacy/UniswapInterfaceMulticall'
import _WethAbi from './abis-legacy/weth'

export const GPv2SettlementAbi = _GPv2SettlementAbi
export const ComposableCoWAbi = _ComposableCoWAbi
export const vCowAbi = _vCowAbi
export const SignatureVerifierMuxerAbi = _SignatureVerifierMuxerAbi
export const MerkleDropAbi = _MerkleDropAbi
export const TokenDistroAbi = _TokenDistroAbi
export const CoWSwapEthFlowAbi = _CoWSwapEthFlowAbi
export const SBCDepositContractAbi = _SBCDepositContractAbi
export const AirdropAbi = _AirdropAbi
export const CowShedContractAbi = _CowShedContractAbi

export const ArgentWalletContractAbi = _ArgentWalletContractAbi
export const ArgentWalletDetectorAbi = _ArgentWalletDetectorAbi
export const Eip2612Abi = _Eip2612Abi
export const EnsPublicResolverAbi = _EnsPublicResolverAbi
export const EnsAbi = _EnsAbi
export const Erc1155Abi = _Erc1155Abi
export const Erc20Abi = _Erc20Abi
export const Erc20Bytes32Abi = _Erc20Bytes32Abi
export const Erc721Abi = _Erc721Abi
export const WethAbi = _WethAbi
export const UniswapInterfaceMulticallAbi = _UniswapInterfaceMulticallAbi
export const Multicall3Abi = _Multicall3Abi
